import React from 'react';
import { MakeRequest } from '../lib/network';
import { getUser, saveUser } from '../lib/user';
import GameButton from '../components/GameButton';

const Logout = (props) => {
    const [message, setMessage] = React.useState("Click To Log Out");

    function DoLogout(event) {
        
        setMessage("Logging out...");   
        console.log('Logout');        
        const user = getUser();
        MakeRequest('logout', {
            email: user.email
        }).then((data) => {
            // delete local storage
            localStorage.removeItem('user');
            console.log('Success:', data);
            setMessage(data.message);

            if (data.success) {
                window.location.href = '/';
            }

            props.setPage && props.setPage("login");
        })
        .catch((error) => {
            console.error('Error:', error);
            setMessage("Error");
        });
    }

    return (
        <div>
            <header className="App-header">
                <form>
                    <div>{message}</div>
                    <GameButton type="submit" to={DoLogout}>Log Out</GameButton>
                </form>
            </header>

        </div>
    );
};

export default Logout;